/**
 * Genesis-progress extraction (WSRPDM-0038, handoff §K2/§K3, spec §2).
 *
 * `backfill[]` is the date-window cursor list; sales no longer syncs on date
 * windows, so `SALES_SYNC` stopped appearing there. `genesis[]` is the
 * forward-looking progress surface both the roster and the tenant detail
 * overview should read from — see `./GenesisProgress.tsx` for the shared
 * rendering both call sites use.
 */
import type { GenesisProgressView, PlatformTenantSummary } from '@/api/wsr/types';

/**
 * Returns `summary.genesis ?? []` — nothing derived from `backfill[]`. When
 * `genesis` is absent (pre-deploy), callers fall back to rendering the
 * existing `backfill[]` output unchanged; that fallback lives at each call
 * site, gated on `summary.genesis !== undefined`, not in this helper.
 */
export function progressEntries(summary: PlatformTenantSummary): GenesisProgressView[] {
  return summary.genesis ?? [];
}
